export default "__VITE_ASSET__BWMtUoiR__"